module.exports = __webpack_public_path__ + "static/media/120.471e4398.svg";